// pp-calc-conversor.js — Conversor de Unidades de Empaque
// (/pages/conversor-de-unidades-de-empaque)
//
// Todas las conversiones del mundo del empaque en una sola página, EN VIVO
// (sin botón): espesor calibre ↔ micras ↔ mils (micras = calibre × 0.254,
// la misma verdad física del verificador de emplaye), longitud cm ↔ pulgadas
// y m ↔ pies, peso kg ↔ lb, y peso volumétrico L×A×H ÷ 5,000 (el divisor de
// Estafeta/FedEx/DHL en México).
//
// ECT y Mullen NO se convierten: son pruebas distintas (canto comprimido vs
// estallido de la pared). ECT_MULLEN es una tabla orientativa de equivalencias
// de USO común — dato editorial, no fórmula — y así se presenta en la página.
// Aritmética pura probada en tests/calc-conversor.test.mjs.
(function (root) {
  'use strict';

  var MICRAS_POR_CALIBRE = 0.254;
  var MICRAS_POR_MIL = 25.4;
  var CM_POR_PULGADA = 2.54;
  var M_POR_PIE = 0.3048;
  var KG_POR_LB = 0.45359237;
  var DIVISOR_VOLUMETRICO = 5000;

  // Equivalencia de USO común (qué caja se compra para el mismo trabajo).
  // NO es conversión matemática: ECT mide compresión de canto, Mullen mide
  // estallido. Es DATO, no fórmula.
  var ECT_MULLEN = [
    { ect: 23, mullen: '150#' },
    { ect: 32, mullen: '200#' },
    { ect: 44, mullen: '275#' },
    { ect: 48, mullen: '350#' }
  ];

  function calibreAMicras(c) { return op(c, function (v) { return v * MICRAS_POR_CALIBRE; }); }
  function micrasACalibre(m) { return op(m, function (v) { return v / MICRAS_POR_CALIBRE; }); }
  function milsAMicras(m) { return op(m, function (v) { return v * MICRAS_POR_MIL; }); }
  function micrasAMils(m) { return op(m, function (v) { return v / MICRAS_POR_MIL; }); }
  function calibreAMils(c) { return op(c, function (v) { return (v * MICRAS_POR_CALIBRE) / MICRAS_POR_MIL; }); }
  function milsACalibre(m) { return op(m, function (v) { return (v * MICRAS_POR_MIL) / MICRAS_POR_CALIBRE; }); }

  function cmAPulgadas(cm) { return op(cm, function (v) { return v / CM_POR_PULGADA; }); }
  function pulgadasACm(inch) { return op(inch, function (v) { return v * CM_POR_PULGADA; }); }
  function mAPies(m) { return op(m, function (v) { return v / M_POR_PIE; }); }
  function piesAM(ft) { return op(ft, function (v) { return v * M_POR_PIE; }); }

  function kgALb(kg) { return op(kg, function (v) { return v / KG_POR_LB; }); }
  function lbAKg(lb) { return op(lb, function (v) { return v * KG_POR_LB; }); }

  // L×A×H en cm ÷ 5,000 → kg volumétricos. null si falta cualquier lado.
  function pesoVolumetrico(largoCm, anchoCm, altoCm) {
    var l = num(largoCm), a = num(anchoCm), h = num(altoCm);
    if ([l, a, h].some(function (v) { return v === null || v <= 0; })) return null;
    return (l * a * h) / DIVISOR_VOLUMETRICO;
  }

  function op(x, fn) {
    var v = num(x);
    return v === null ? null : fn(v);
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPConversorEmpaque = {
    MICRAS_POR_CALIBRE: MICRAS_POR_CALIBRE,
    MICRAS_POR_MIL: MICRAS_POR_MIL,
    CM_POR_PULGADA: CM_POR_PULGADA,
    M_POR_PIE: M_POR_PIE,
    KG_POR_LB: KG_POR_LB,
    DIVISOR_VOLUMETRICO: DIVISOR_VOLUMETRICO,
    ECT_MULLEN: ECT_MULLEN,
    calibreAMicras: calibreAMicras,
    micrasACalibre: micrasACalibre,
    milsAMicras: milsAMicras,
    micrasAMils: micrasAMils,
    calibreAMils: calibreAMils,
    milsACalibre: milsACalibre,
    cmAPulgadas: cmAPulgadas,
    pulgadasACm: pulgadasACm,
    mAPies: mAPies,
    piesAM: piesAM,
    kgALb: kgALb,
    lbAKg: lbAKg,
    pesoVolumetrico: pesoVolumetrico
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
// Cada bloque .pp-calc__tool convierte al teclear: el campo que editas manda,
// los hermanos se rellenan (input.value) y los readouts van por textContent.
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-conversor]');
    if (!raiz) return;
    var C = window.PPConversorEmpaque;

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 2 : dec });
    }

    // Redondeo corto para rellenar inputs hermanos sin colas de flotante.
    function corto(n) {
      return Math.round(n * 10000) / 10000;
    }

    // Enlaza un grupo de inputs equivalentes: al teclear en uno, los demás se
    // rellenan con su conversión DESDE el que se editó.
    // grupo: [{ input, desde: { <name del hermano>: fn } }]
    function enlazar(inputs, conversiones) {
      inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          var origen = input.name;
          inputs.forEach(function (destino) {
            if (destino === input) return;
            var fn = conversiones[origen] && conversiones[origen][destino.name];
            if (!fn) return;
            var v = fn(input.value);
            destino.value = v === null ? '' : String(corto(v));
          });
        });
      });
    }

    function inputPor(bloque, name) {
      return bloque.querySelector('input[name="' + name + '"]');
    }

    // ── (1) Espesor: calibre ↔ micras ↔ mils ──
    var bEspesor = raiz.querySelector('[data-conv-espesor]');
    if (bEspesor) {
      var iCal = inputPor(bEspesor, 'calibre');
      var iMic = inputPor(bEspesor, 'micras');
      var iMil = inputPor(bEspesor, 'mils');
      enlazar([iCal, iMic, iMil], {
        calibre: { micras: C.calibreAMicras, mils: C.calibreAMils },
        micras: { calibre: C.micrasACalibre, mils: C.micrasAMils },
        mils: { calibre: C.milsACalibre, micras: C.milsAMicras }
      });
    }

    // ── (2) Longitud: cm ↔ pulgadas y m ↔ pies ──
    var bLongitud = raiz.querySelector('[data-conv-longitud]');
    if (bLongitud) {
      enlazar([inputPor(bLongitud, 'cm'), inputPor(bLongitud, 'pulgadas')], {
        cm: { pulgadas: C.cmAPulgadas },
        pulgadas: { cm: C.pulgadasACm }
      });
      enlazar([inputPor(bLongitud, 'metros'), inputPor(bLongitud, 'pies')], {
        metros: { pies: C.mAPies },
        pies: { metros: C.piesAM }
      });
    }

    // ── (3) Peso: kg ↔ lb ──
    var bPeso = raiz.querySelector('[data-conv-peso]');
    if (bPeso) {
      enlazar([inputPor(bPeso, 'kg'), inputPor(bPeso, 'lb')], {
        kg: { lb: C.kgALb },
        lb: { kg: C.lbAKg }
      });
    }

    // ── (4) Peso volumétrico: L×A×H ÷ 5,000 ──
    var bVol = raiz.querySelector('[data-conv-volumetrico]');
    if (bVol) {
      var salida = bVol.querySelector('[data-conv-vol-resultado]');
      function volumetrico() {
        var r = C.pesoVolumetrico(
          inputPor(bVol, 'largo').value,
          inputPor(bVol, 'ancho').value,
          inputPor(bVol, 'alto').value
        );
        if (salida) salida.textContent = r === null ? '—' : fmt(r, 2) + ' kg';
      }
      bVol.addEventListener('input', volumetrico);
    }
  });
})();
